<template>
    <div class="container">
        <ul class="expert-list">
            <li v-for="(item,index) in judgesList" :key="index">
                <div class='ju-imag'>
                    <img :src="item.picUrl" />
                </div>
                <div class="expert-txt">
                    <span class="expert-name">{{item.judgesName}}</span>
                    <span class="text-opacity">{{item.position}}</span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
export default {
    name: 'competitionExpert',
    components: {

    },
    data() {
        return {
            id: '', //大赛id
            judgesList: [] //专家团队
        }
    },
    created() {
        this.id = this.$route.query.id
        this.getDataCompetition()
    },
    methods: {
        //获取专家团队数据
        async getDataCompetition() {
            let param = {
                competitionId: this.id
            }
            ajaxParam(param)
            const res = await post('v1/competition/judgesList', qs.stringify(param))
            if (res.data.code == 200) {
                this.judgesList = res.data.list
            } else {
                this.$message.error(res.data.msg)
            }
        }
    }
}
</script>
<style lang="less" scoped>
.expert-list {
    display: flex;
    flex-wrap: wrap;

    li {
        display: flex;
        flex-direction: column;
        width: 184px;

        margin-left: 10px;
        margin-bottom: 10px;

        .ju-imag {
            height: 200px;
            display: flex;
            align-items: center;

            img {
                max-width: 184px;
                max-height: 184px;
            }
        }

        .expert-txt {
            width: 100%;
            height: 64px;
            background: #F3F4F7;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;

            .expert-name {
                width: 90%;
                padding-bottom: 3px;
                font-size: 18px;
                font-weight: bold;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .text-opacity {
                width: 90%;
                line-height: 22px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                box-sizing: border-box;
                text-align: center;
            }
        }
    }
}
</style>